/**
 * Created by bscholl on 10.02.17.
 */
import CoreEvent from '@/core/event/coreEvent';

export default class StepEvent extends CoreEvent {

    static get STEP_FINISHED() {
        return 'StepEvent.stepFinished';
    }

}
